import styled from 'styled-components';
import { getSpacingToken } from '@optimus-web/common';

export const CheckboxGroupContainer = styled.fieldset`
    margin: 0;
    padding: 0;
    border: 0;
`;

export const NestedGroupWrapper = styled.div`
    margin-left: ${getSpacingToken('300')}px;
`;

export const CheckboxesContainer = styled.div`
    margin: ${getSpacingToken('100')}px 0;
`;
